import { useCancelAttendanceMutation } from '../../features/SpeechAgendaApiSlice.ts'
import { useEffect, useState } from 'react'
import {
  formatRoleCancellationResponse,
  parseErrorResponse,
} from '../../utils/FormatterUtils.ts'
import { AssignRoleResponse, AssignRoleState } from '../../types/Types.ts'

export function useCancelRole(): [
  AssignRoleResponse | null,
  AssignRoleState,
  (
    clubId: string,
    meetingTimestampUtc: string,
    roleId: number | undefined
  ) => Promise<void>,
] {
  const [cancelRoleResponse, setCancelRoleResponse] =
    useState<AssignRoleResponse | null>(null)
  const [cancelRoleState, setCancelRoleState] =
    useState<AssignRoleState>('NOT_STARTED')
  const [cancelAttendance, cancelAttendanceResult] =
    useCancelAttendanceMutation()

  const performCancelAttendance = async (
    clubId: string,
    meetingTimestampUtc: string,
    roleId: number | undefined
  ) => {
    setCancelRoleState('PROCESSING')
    if (!clubId || !meetingTimestampUtc || !roleId) {
      console.error(
        `Missing required parameters for cancellation: clubId: ${clubId}, meetingTimestampUtc: ${meetingTimestampUtc}, roleId: ${roleId}`
      )
      setCancelRoleState('ERROR')
      return
    }
    cancelAttendance({ clubId, meetingTimestampUtc, body: { roleId } })
  }

  //Cancel Success
  useEffect(() => {
    if (
      !cancelAttendanceResult.isLoading &&
      !cancelAttendanceResult.isUninitialized &&
      cancelAttendanceResult.data
    ) {
      const { title, description } = formatRoleCancellationResponse(
        cancelAttendanceResult.data
      )
      setCancelRoleResponse({ title, description })
      setCancelRoleState('SUCCESS')
    }
  }, [cancelAttendanceResult])

  //Cancel Role Error
  useEffect(() => {
    if (
      !cancelAttendanceResult.isLoading &&
      !cancelAttendanceResult.isUninitialized &&
      cancelAttendanceResult.error
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      const error = cancelAttendanceResult.error.data as BaseResponse
      const { title, description } = parseErrorResponse(error)
      setCancelRoleResponse({ title, description })
      setCancelRoleState('ERROR')
    }
  }, [cancelAttendanceResult])

  return [cancelRoleResponse, cancelRoleState, performCancelAttendance]
}
